import React from "react";
import { useState } from "react";
import Header from "./aboutUsHeader.tsx";
import Footer from "./../home/footer.jsx";
import TimelineComponent from "./componts/timeline.tsx";
import "./componts/styles.css";
import mission from "../home/imgs/mission.png";
import vision from "../home/imgs/vission.png";
import me from "../home/imgs/1.png";
import "tailwindcss/tailwind.css";
import LeadershipTeam from "./componts/team.tsx";
import TestimonialCard from "./componts/testimonials.tsx";
import Awards from "./componts/award.tsx";
import Gallery from "./componts/gallery.tsx";
import Faq from "./componts/faq.tsx";
import ContactInfo from "./componts/ContactInfo.tsx";
import { Link } from "react-scroll";
import image from "./../home/imgs/headerbg.jpg"

const MoreAboutUs = () => {

  const team = [
    {
      id: 1,
      name: "John Doe",
      title: "CEO & Founder",
      image: vision,
      bio: "John is the founder and CEO of our company, with a vision for growth and leadership in the tech world.",
      social: {
        linkedin: "https://linkedin.com/in/johndoe",
        twitter: "https://twitter.com/johndoe",
      },
    },
    {
      id: 2,
      name: "Jane Smith",
      title: "CTO",
      image: mission,
      bio: "Jane is the chief technology officer and leads the engineering team to success.",
      social: {
        linkedin: "https://linkedin.com/in/janesmith",
        twitter: "https://twitter.com/janesmith",
      },
    },
    // Add more team members as needed
  ];

  // State for modal visibility and selected team member
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  // Function to open modal
  const openModal = (member) => {
    setSelectedMember(member);
    setIsOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setSelectedMember(null);
    setIsOpen(false);
  };

  return (
    <>
      <Header />

      {/* home section  */}

      <div
        id="companyHistory"
        className="headerbg max-w-7xl mx-auto sm:flex w-full order"
      >
        <div
          data-aos="flip-right"
          data-aos-duration="2000"
          className="sm:w-72 w-full order-2 sm:order-1"
         >
          <TimelineComponent />
        </div>
      </div>
      {/* mission section  */}
      <div
        id="MissionAndVision"
        className="max-w-7xl mx-auto sm:flex"
      >
        <div className="  sm:w-1/2 w-full flex items-center">
          <img
            src={mission}
            alt="GrandShopMission"
            className="w-3/4 items-center flex justify-center h-auto m-8"
          />
        </div>
        <div className="  sm:w-1/2 w-full">
          <h1 className="text-3xl font-bold text-[#3A636C] my-8 text-center">
            <span className="me-2 text-customBlue">Our</span>Mission
          </h1>
          <p className="p-4">
            At Grand Shop Rwanda, our mission is to provide a diverse range of
            high-quality products that enhance everyday life. We prioritize
            customer satisfaction through exceptional service, local sourcing,
            and sustainable practices, fostering trust and loyalty within our
            vibrant community.
          </p>
        </div>
      </div>

      {/* vision section  */}
      <div className="max-w-7xl mx-auto sm:flex">
        <div className="order-1 sm:order-2  sm:w-1/2 w-full flex items-center ">
          <img
            src={vision}
            alt="GrandShopMission"
            className="w-3/4 items-center flex justify-center h-auto m-8"
          />
        </div>
        <div className="order-2 sm:order-1 sm:w-1/2 w-full ">
          <h1 className="text-3xl font-bold  my-8 text-customBlue  text-center">
            <span className="me-2 text-[#3A636C]">Our</span>
            Mission
          </h1>
          <p className="p-4">
            Grand Shop Rwanda, our vision is to be the leading retail
            destination, delivering exceptional products and services while
            fostering trust and loyalty within our community. We aim to empower
            local businesses and enhance the shopping experience for all.
          </p>
        </div>
      </div>

      {/* team  */}
      <div id="Team" className="max-w-7xl mx-auto">
        <LeadershipTeam />
      </div>

      {/* testimonies  */}
      <div
        id="TestimonialsAndCaseStudies"
        className="max-w-7xl mx-auto"
      >
        <TestimonialCard />
      </div>
      {/* awards section  */}
      <div id="AwardsAndRecognition" className="mx-auto awardBg">
        <div className="awardMaskBg h-full">
          <div className="mx-10">
            <Awards />
          </div>
        </div>
      </div>

      {/* Gallery section  */}
      <div id="VisualGallery" className="mx-auto">
        <Gallery />
      </div>

      {/* faq  */}
      <div id="FAQs" className="mx-auto">
        <Faq />
      </div>

      {/* contact info  */}
      <div id="GetInTouch" className="mx-auto">
        <ContactInfo />
      </div>
      <div id="GetInTouch" className="mx-auto">
        <Footer />
      </div>
    </>
  );
};

export default MoreAboutUs;
